export const VALIDATION = {
  MASTER_EXISTS: 'Record with same code is already exists',
};

export const RESPONSE_CODE = {
  DEFAULT: "SUCCESS",
  ERROR: "ERROR",
};

export const success = 200;
export const create = 201;
export const internalServerError = 500;
export const validationError = 422;